import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import VueCookies from 'vue-cookies'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'leaflet/dist/leaflet.css'
import 'photoswipe/dist/photoswipe.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import '@fortawesome/fontawesome-free/css/all.css'
import ScrollDiv from 'vue-scroll-div'
import { RouteLeaf } from '@/my-leaf/routes/route-leaf'
import { createPinia, PiniaVuePlugin } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import { ShipLeaf } from '@/my-leaf/ships/ship-leaf'
import { EditorLeaf } from '@/my-leaf/editor/editor-leaf'
import { HomeLeaf } from '@/my-leaf/home/home-leaf'
import { commit } from './version'
import { useVersionStore } from '@/stores/version'
import notificationService from '@/views/dialogs/NotificationService'

console.error("Build hash:", commit);
window.buildCommit = commit;

export const eventBus = new Vue()

Vue.config.productionTip = false

Vue.component('font-awesome-icon', FontAwesomeIcon)

// Инициализируем Pinia до инициализации карт (из Pinia будем брать состояние карты для инициализации)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

Vue.use(PiniaVuePlugin)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(require('vue-cookies'))
Vue.use(VueCookies, { expire: '1d' })
Vue.use(ScrollDiv)

// Добавляем сервис уведомлений в глобальные свойства Vue
Vue.prototype.$notify = notificationService

// Создаем экземпляры карт после инициализации Pinia
export const routes_map = new RouteLeaf()
export const logbooks_map = new ShipLeaf()
export const home_map = new HomeLeaf()
export const editor_map = new EditorLeaf()

new Vue({
  router,
  store,
  pinia,
  i18n,
  render: h => h(App),
}).$mount('#app')

const versionStore = useVersionStore()
versionStore.initAppVersion()
